<template>
  <div class="flex masonry-openended-container">
    <div
      v-masonry
      :transition-duration="`${masonryTransitionDuration}ms`"
      item-selector=".item"
      class="masonry-content"
    >
      <div
        v-masonry-tile
        v-for="(option, optionIndex) in slideActive.openEndedAIGroupedAnswers"
        :key="option.id"
        class="item"
      >
        <div
          class="body-content"
          :style="{ 'box-shadow': setBoxShadowValue(option, optionIndex),
                    'background-color': getOpenEndedBackground()}"
          :class="{'has-audience-info': option.audienceName
                     || option.audienceTeam || option.audienceEmoji || option.audienceEmail,
                   'hidden': !option.answers.length}"
          @click="$emit('pickOption', option, optionIndex)"
        >
          <p class="body-content__group-title">
            {{ option.groupTitle }}
          </p>
          <ul v-for="answer in option.answers" :key="answer.id" class="body-content__group-items">
            <li>
              <span v-if="answer.title">{{ answer.title }}</span>
              <ButtonEnlargeImage
                v-if="answer.image"
                :image="answer.image"
                class="content-image"
                :class="{'mt-0': !answer.title && answer.image}"
                v-show="answer.image && imageSubmission"
                :noContent="!answer.title && !imageSubmission"
              />
              <div
                class="audience-info"
                :class="{'dark': isTextColourWhite}"
                v-show="_checkShowAudienceInfo(option)"
              >
                <div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import ButtonEnlargeImage from '@/components-v2/presentation-editor/middle/ButtonEnlargeImage.vue'

export default {
  components: {
    ButtonEnlargeImage,
  },
  props: {
    masonryTransitionDuration: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      imageSubmission: (state) => state.slideActive.imageSubmission,
    }),

    isTextColourWhite() {
      return this.slideActive.textColour == '#ffffff'
    },
  },
  methods: {
    setToColorPalette(option, optionIndex) {
      return utils.setToColorPalette(option, optionIndex)
    },
    setBoxShadowValue(option, optionIndex) {
      return `0 0 0 1.5px ${utils.setToColorPalette(option, optionIndex)}`
    },
    getOpenEndedBackground() {
      const color = utils.hexToRgba(this.$store.state.slideActive.baseColour)
      return utils.changeRgbaColor(color, 0.6)
    },
    _checkShowAudienceInfo(answer) {
      return utils.checkShowAudienceInfo(answer)
    },
  },
}
</script>
<style lang="scss" scoped>
.masonry-openended-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .item {
    padding: 14px 11px 7px 11px;
    width: calc(100% / 3);
    z-index: 9;

    .body-content {
      border-radius: 8px;
      transition: all 0.25s;
      cursor: pointer;
      word-break: break-word;
      position: relative;
      padding: 10px 16px;
      &:hover {
        transform: scale(1.05);
        .remove-icon {
          opacity: 0.5;
          &:hover {
            opacity: 1;
          }
        }
        .button-voice {
          display: block;
        }
      }
      .body-content__group-title {
        @apply font-bold text-2xl pb-2;
      }
      .body-content__group-items {
        @apply pl-8;
      }
    }
    &:hover {
      z-index: 20;
    }
  }
}
.content-image {
  @apply mt-2;
  &::v-deep .enlarge-image__image {
    max-height: 92px;
    max-width: 100%;
  }
}
</style>
